import { useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';

const AnchorAds_Id = "2085253573";
const InArticleNative_TopDeskId = "6650374378";
const InArticleNative_Id = "1048058946";

const pushAd = () => {
  const push = () => {
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));
    idle(() => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error("Ad failed to load", e);
      }
    });
  };

  if (document.readyState === 'complete') {
    push();
  } else {
    window.addEventListener('load', push, { once: true });
  }
};

const AdComponent = ({ adSlot, isAnchor = false, fullWidthResponsive = true }) => {
  useEffect(() => {
    pushAd();
  }, [adSlot]);

  return (
    <ins
      className="adsbygoogle"
      style={isAnchor ? { display: 'block', height: '100px', width: '100%' } : { display: 'block' }}
      data-ad-client="ca-pub-7107245842042491"
      data-ad-slot={adSlot}
      data-cfasync="false"
      data-ad-format={isAnchor ? 'horizontal' : 'auto'}
      data-full-width-responsive={isAnchor ? 'false' : String(fullWidthResponsive)}
    ></ins>
  );
};

const LazyAd = ({ adSlot, style, fullWidthResponsive = true }) => {
  const [shouldLoadAd, setShouldLoadAd] = useState(false);
  const adRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoadAd(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );
    if (adRef.current) observer.observe(adRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={adRef} style={style}>
      {shouldLoadAd && <AdComponent adSlot={adSlot} fullWidthResponsive={fullWidthResponsive} />}
    </div>
  );
};

export const AnchorTopAds = () => {
  const [pageLoaded, setPageLoaded] = useState(
    () => document.readyState === 'complete'
  );

  useEffect(() => {
    if (pageLoaded) return;
    const onLoad = () => setPageLoaded(true);
    window.addEventListener('load', onLoad, { once: true });
    return () => window.removeEventListener('load', onLoad);
  }, []);

  if (!pageLoaded) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100px',
      backgroundColor: 'white',
      overflow: 'hidden',
      zIndex: 1000
    }}>
      <AdComponent adSlot={AnchorAds_Id} isAnchor />
    </div>
  );
};

export const FirstAds = () => (
  !isMobile
    ? <><LazyAd adSlot={InArticleNative_TopDeskId} style={{ height: '280px', backgroundColor: 'white' }} /><br /></>
    : null
);

export const SecondAds = () => (
  <><br /><LazyAd adSlot={InArticleNative_Id} style={{ height: '280px', backgroundColor: 'white' }} fullWidthResponsive={!isMobile} /></>
);

export const MobileUnderCalAds = () => (
  isMobile
    ? <><LazyAd adSlot={InArticleNative_Id} style={{ height: '280px', backgroundColor: 'white' }} /><br /></>
    : null
);

export default AnchorTopAds;